import { useStore } from '@nanostores/react';
import { Tabs } from '~/components/ui/Tabs';
import { sendAnalyticsEvent } from '~/lib/analytics.client';
import { pricingStore } from '~/lib/stores/pricing/pricing';
import { userStore } from '~/lib/stores/user';
import { AnalyticsAction, AnalyticsTrackEvent } from '~/types/analytics';
import { classNames } from '~/utils/classNames';

interface Props {
  className?: string;
}

export const PricingIntervalSelector = ({ className }: Props) => {
  const selectedInterval = useStore(pricingStore.selectedInterval);

  const handleIntervalChange = (newInterval: string) => {
    const user = userStore.getUser();
    const activeOrganization = userStore.getActiveOrganization().get();

    sendAnalyticsEvent({
      action: AnalyticsAction.Track,
      payload: {
        event: AnalyticsTrackEvent.BillingIntervalChanged,
        properties: {
          // user context (who triggered the action)
          user_email: user?.email,
          user_id: user?.id,

          // interval context
          previous_interval: selectedInterval,
          new_interval: newInterval,

          // context about what they're viewing
          active_organization_id: activeOrganization?.id,
          user_current_tier: user?.membership?.tier,

          // action context
          location: 'pricing_page',
        },
      },
    });
    pricingStore.selectedInterval.set(newInterval as 'monthly' | 'yearly');
  };

  return (
    <div className={classNames('flex gap-4', className)}>
      <Tabs
        items={[
          { value: 'monthly', label: 'Monthly' },
          { value: 'yearly', label: 'Yearly' },
        ]}
        selectedTab={selectedInterval}
        onTabChange={handleIntervalChange}
      />

      <p
        className={classNames(
          'h-6 text-sm font-medium text-bolt-ds-textPrimary',
          selectedInterval === 'yearly' ? 'op-0' : '',
        )}
      >
        <b>Save 10%</b> on a yearly subscription
      </p>
    </div>
  );
};
